import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/SamanthaTy/sty-portfolio'
      className='link footer__link'
    >
      Created By Samantha Ty
    </a>
  </footer>
)

export default Footer
